module.exports = __webpack_public_path__ + "img/gdq_gbt884_1986.prt.81015af8.jpg";